var chunkToChildrenMap = {
	"7672": [
		15364,
		99393
	],
	"20164": [
		15364,
		99393
	],
	"38232": [
		15364
	],
	"80507": [
		15364,
		99393
	],
	"83548": [
		15364,
		99393
	],
	"92654": [
		15364
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));